import { InjectionToken } from '@angular/core';
import { RootErrorsConfig } from '../model';

export const ERRORS_CONFIG = new InjectionToken<RootErrorsConfig>('ERRORS_CONFIG');
